// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-joined-banner {
  display: inline-block;
  width: 100%;
  padding: 12px 16px;
  animation-name: bubbleAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.agent-joined-banner .agent-joined-wrapper {
  text-align: center;
  padding: 8px;
  border-radius: 4px;
}
.agent-joined-banner .agent-joined-wrapper.agent-joined-variation-1 .agent-name {
  background: var(--agent-joined-bg);
  margin: 4px 0;
}
.agent-joined-banner .agent-joined-wrapper.agent-joined-variation-2 {
  border: 1px solid var(--agent-joined-border);
}
.agent-joined-banner .agent-joined-wrapper.agent-joined-variation-2 .agent-name {
  margin: 6px 0 0px 0;
}
.agent-joined-banner .agent-joined-wrapper .img-block {
  width: 24px;
  height: 24px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}
.agent-joined-banner .agent-joined-wrapper .img-block figure {
  line-height: 0px;
}
.agent-joined-banner .agent-joined-wrapper .img-block img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 1.5px solid var(--sdk-global-white-bg);
}
.agent-joined-banner .agent-joined-wrapper .agent-name {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--agent-joined-text-color);
  padding: 4px 8px;
  display: inline-block;
  border-radius: 32px;
}
.agent-joined-banner .agent-joined-wrapper .time-stamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--agent-joined-text-color);
  direction: ltr;
  unicode-bidi: isolate;
}
.agent-joined-banner .agent-joined-wrapper .time-stamp time {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/system/system.scss"],"names":[],"mappings":"AACA;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AAAJ;AACI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;AACR;AACY;EACI,kCAAA;EACA,aAAA;AAChB;AAEQ;EACI,4CAAA;AAAZ;AACY;EACI,mBAAA;AAChB;AAEQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAAZ;AACY;EACI,gBAAA;AAChB;AACY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;AAChB;AAEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;AAAZ;AACY;EACI,eAAA;AAChB","sourcesContent":["// Agent Joined Banner\n.agent-joined-banner{\n    display: inline-block;\n    width: 100%;\n    padding: 12px 16px;\n    animation-name: bubbleAnim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    .agent-joined-wrapper{\n        text-align: center;\n        padding: 8px;        \n        border-radius: 4px;\n        &.agent-joined-variation-1{\n            .agent-name{\n                background: var(--agent-joined-bg);\n                margin: 4px 0;\n            }\n        }\n        &.agent-joined-variation-2{\n            border: 1px solid var(--agent-joined-border);\n            .agent-name{\n                margin: 6px 0 0px 0;\n            }\n        }\n        .img-block{\n            width: 24px;\n            height: 24px;\n            margin: 0 auto;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-top: -20px;\n            figure{\n                line-height: 0px;\n            }\n            img{\n                width: 100%;\n                height: 100%;\n                border-radius: 100%;\n                border: 1.5px solid var(--sdk-global-white-bg);\n            }\n        }\n        .agent-name{\n            font-weight: 600;\n            font-size: 12px;\n            line-height: 15px;\n            color: var(--agent-joined-text-color);\n            padding: 4px 8px;\n            display: inline-block;            \n            border-radius: 32px;\n        }\n        .time-stamp{\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 15px;\n            color: var(--agent-joined-text-color);\n            direction: ltr;\n            unicode-bidi: isolate;\n            time{\n                font-size: 12px;\n            }\n        }\n    }\n}\n// End"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
